import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=2b5e4cb8&scoped=true&"
import script from "./AuthLayout.vue?vue&type=script&lang=js&"
export * from "./AuthLayout.vue?vue&type=script&lang=js&"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=2b5e4cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e4cb8",
  null
  
)

export default component.exports